import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const BoundingBox = t0 => {
  const $ = _c(12);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M4.9984 2H2V4.9984H4.9984V2Z" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M4.9978 3.50098H18.998" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M3.49878 4.99805V19" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M20.4968 4.99951V19.0015" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M4.9978 20.501H18.998" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t6 = <path d="M4.9984 19H2V21.9984H4.9984V19Z" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M21.9964 2.00195H18.998V5.00035H21.9964V2.00195Z" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t8 = <path d="M21.9964 19.002H18.998V22.0004H21.9964V19.002Z" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] !== props) {
    t9 = <IconWrapper {...props} variant="outline">{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</IconWrapper>;
    $[10] = props;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
};
export { BoundingBox };